<p-confirmDialog key="override" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="Grid2Col">
	<label>Student:</label>
	<label>{{ StudentName }}</label>

	<label>Student ID:</label>
	<label>{{ StudentID }}</label>

	<label>District Override Policy</label>
	<textarea rows="6" disabled class="TextArea">{{ MTAOverrideMessage }}</textarea>

	<label>Override Reason:</label>
	<select class="form-control" name="ReasonSelector" [(ngModel)]="SelectedReason">
		<option *ngFor="let r of lstReason" [ngValue]="r.MTAOverrideReasonID">
			{{ r.MTAOverrideReasonDesc }}
		</option>
	</select>
</div>

<div class="Buttons TopMargin">
	<button class="btn btn-primary" (click)="onAgree()">Agree</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
